const awradData = {
  brand: "الأوراد",
  List: [
    {
      id: 1,
      title: "ورد الإستغفار",
      text: `  {فَقُلْتُ اسْتَغْفِرُوا رَبَّكُمْ إِنَّهُ كَانَ غَفَّارًا (10) يُرْسِلِ السَّمَاءَ عَلَيْكُم مِّدْرَارًا (11) وَيُمْدِدْكُم بِأَمْوَالٍ وَبَنِينَ وَيَجْعَل لَّكُمْ جَنَّاتٍ وَيَجْعَل لَّكُمْ أَنْهَارًا (12) } [ نوح]`,
    },
    {
      id: 2,
      title: "ورد الصلاة علي النبي",
      text:
        "في كل مرة تحط عنه عشر خطايا ويرفع له عشر درجات ويصلي الله عليه عشرا وتعرض علي الرسول صلي الله عليه وسلم. أي عدد",
    },
    {
      id: 3,
      title: ` لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ، وَلَهُ الْحَمْدُ، وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ - 10 مرات`,
      text: `  قَالَ رسول الله صلى الله عليه وسلم: «مَنْ قَالَ لاَ إِلَهَ إِلاَّ اللَّهُ وَحْدَهُ لاَ شَرِيكَ لَهُ، لَهُ الْمُلْكُ، وَلَهُ الْحَمْدُ، وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ عَشْرَ مِرَات، كَانَ كَمَنْ أَعْتَقَ أَرْبَعَةَ أَنْفُسٍ مِنْ وَلَدِ إِسْمَاعِيلَ».`,
    },
    {
      id: 4,
      title: "سبحان الله وبحمده 100 مرة",
      text: ` قَالَ رسول الله صلى الله عليه وسلم مَنْ قَالَ: «سُبْحَانَ اللَّهِ وَبِحَمْدِهِ فِي يَوْمٍ مِائَةَ مَرَّةٍ حُطَّتْ خَطَايَاهُ وَلَوْ كَانَتْ مِثْلَ زَبَدِ الْبَحْر».`,
    },
    {
      id: 5,
      title: "سبحان الله وبحمده سبحان الله العظيم",
      text: `قَالَ رسول الله صلى الله عليه وسلم: «كَلِمَتَانِ خَفِيفَتَانِ عَلَى اللِّسَانِ، ثَقِيلَتَانِ فِي الْمِيزَانِ، حَبِيبَتَانِ إِلَى الرَّحْمَنِ: سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، سُبْحانَ اللَّهِ الْعَظِيمِ».`,
    },
    {
      id: 6,
      title:
        "سبحان الله والحمد لله ولا إله إلا الله والله أكبر ولا حول ولا قوة إلا بالله",
      text: "يكتب له ألف حسنة أو يحط عنه ألف خطيئة",
    },
  ],
};

export default awradData;
